<template>
  <section class="hero-block">
    <b-container>
      <b-row>
        <b-col lg="5" class="hero-col">
          <div class="img-wrapper">
            <div class="cloud">Для вас есть подарок!</div>
            <img :src="src" alt />
          </div>
        </b-col>
        <b-col lg="7" class="hero-col">
          <h2 class="title" v-html="title"></h2>
          <p v-for="paragraph in paragraphs" :key="paragraph" v-html="paragraph"></p>
        </b-col>
      </b-row>
      <div class="circle"></div>
    </b-container>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    paragraphs: Array,
    src: String
  }
};
</script>